import { HelmetDexteel } from "@dexteel/mesf-core";
import { Button, Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import type React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(4),
		height: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		padding: theme.spacing(4),
		textAlign: "center",
		maxWidth: 600,
		borderRadius: "0.75rem",
	},
	icon: {
		fontSize: 80,
		color: theme.palette.error.main,
		marginBottom: theme.spacing(2),
	},
	title: {
		marginBottom: theme.spacing(2),
		fontWeight: 600,
	},
	message: {
		marginBottom: theme.spacing(4),
	},
	button: {
		marginTop: theme.spacing(2),
	},
}));

const UnauthorizedPage: React.FC = () => {
	const classes = useStyles();

	return (
		<>
			<HelmetDexteel title="Unauthorized" />
			<div className={classes.root}>
				<Paper elevation={3} className={classes.paper}>
					<Grid container direction="column" alignItems="center" spacing={2}>
						<Grid item>
							<ErrorOutlineIcon className={classes.icon} />
						</Grid>
						<Grid item>
							<Typography variant="h4" className={classes.title}>
								401 - Unauthorized
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1" className={classes.message}>
								You don't have permission to access this page. Please contact
								your administrator if you believe this is an error.
							</Typography>
						</Grid>
						<Grid item>
							<Button
								component={Link}
								to="/map/main"
								variant="contained"
								color="primary"
								className={classes.button}
							>
								Go to Main Map
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</div>
		</>
	);
};

export default UnauthorizedPage;
